module.exports = __webpack_public_path__ + "static/media/RavelloWine.282a7250.jpg";